import React, { useEffect, useRef, useState } from "react";
import { useGlobalContext } from "../context/global";
import Dropdownbutton from "../components/Buttons/dropdownbutton";
import SettingsIcon from '@mui/icons-material/Settings';
import { Box, IconButton } from "@mui/material";
import OverviewCardSection from "./HomeDashboardNew/OverviewCardSection/OverviewCardSection";
import PerformanceChart from "./HomeDashboardNew/PerformanceChart";
import PerformanceSummary from "./HomeDashboardNew/PerformanceSummary";
import TargetingInsights from "./HomeDashboardNew/TargetingInsights";
import ProductSummary from "../components/productSummary/productSummary";
import KeyInsightsSection from "../components/keyInsightsSection/keyInsightsSection";
import LowPerformingSearchTerms from "./HomeDashboardNew/LowPerformingSearchTerms";
import CampaignSummary from "./HomeDashboardNew/CampaignSummary";
import DashboardLayoutDialog from "./HomeDashboardNew/DashboardLayoutDialog";
import {
  DEFAULT_DASHBOARD_FILTERS,
  DEFAULT_DASHBOARD_LAYOUT,
  normalizeDashboardLayout,
} from "./HomeDashboardNew/dashboardLayoutConfig";
import { dashboardActions } from "../redux/slices/dashboardSlice";
import { useDispatch, useSelector } from "react-redux";
import "./homeDashboard.css";
// import getClientData from "../helper/clientData/getClientData";
// import calenderIcon from "../assets/icons/calendar_month.png";
import calenderIcon from "../assets/icons/trailing-icon.svg";
import arrowdown from "../assets/icons/down_arrow.svg";
// import PieChart from "../components/pieChart/pieChart";
import CalenderComponent from "../components/calender/Calender";
import closeIcon from "../assets/icons/close_icon.png";
// import ReactDOM from "react-dom";
// import useUserDetails from "../helper/userData/useUserDetails";
import { Link, useNavigate } from "react-router-dom";
import DataLastUpdated from '../components/Breadcrumb/DataLastUpdated';
import DashboardPortfolioSelect from './HomeDashboardNew/DashboardPortfolioSelect';
import { generateIFrameReportUrl } from "../helper/clientData/utils";
import HomeDashboardNew from "./HomeDashboardNew/HomeDashboardNew";

const HomeDashboard = (props) => {
  const {
    calendarDate,
    setCalendarDate,
    applyCalendar,
    selectedPortfolios,
    setselectedPortfolios,
    dashboardLayoutSequence,
    setDashboardLayoutSequence,
    clientId,
    setItemList,
    overlayoutput,
    selectedPlatform
  } = useGlobalContext();
  const [portfolioIdByName, setPortfolioIdByName] = useState({});
  const [Optionactive, setOptionactive] = useState(false);
  const [Brandoption, setBrandoption] = useState(false);
  const [modalShow, setModalDashboard] = useState(false);
  const [dashboardFilters, setDashboardFilters] = useState(DEFAULT_DASHBOARD_FILTERS);
  const updateDashboardFilters = (partial) => {
    setDashboardFilters((current) => ({ ...current, ...partial }));
  };
  const [dateInFocus, setDateInFocus] = useState("text");
  const [showCustomDateBox, setShowCustomDateBox] = useState(false);
  const [datecomp, setdatecomp] = useState(false);
  const closeRef = useRef();
  const navigate = useNavigate();
  const { dateDifference, setDateDifference } = useGlobalContext();
  const dispatch = useDispatch();
  const dashboardSideBarVisibiltyState = useSelector(
    (state) => state.dashboardData.dashboardSideBarVisibiltyState
  );
  const dasboardLayoutSettingModalShow = useSelector(
    (state) => state.dashboardData.dasboardLayoutSettingModal
  );
  const client_id = JSON.parse(localStorage.getItem("clientId"));
  const [selectedPortfolioName, setSelectedPortfolioName] =
    useState([]);
  const calenderIconRefForDashboard = useRef(null);
  // const [dashboardLayoutSequence, setDashboardLayoutSequence] = useState([ "trend_graph", "campaign_summary", "category_product_performance_summary", "targeting", "low_performing_search_terms", "product_summary"]);
  const handledateremove = (e) => {
    setShowCustomDateBox(false);
  };

  const portfoliosIds = selectedPortfolioName
    .map((name) => portfolioIdByName[name])
    .filter(Boolean);
  const client_type = JSON.parse(localStorage.getItem("client_account_type"))

  const datecount = JSON.parse(localStorage.getItem("datecount"));
  // const [userDetails] = useUserDetails();

  useEffect(() => {
    const checkIfClickedOutside = (e) => {
      // If the menu is open and the clicked target is not within the menu,
      // then close the menu
      if (
        Optionactive &&
        closeRef.current &&
        !closeRef.current.contains(e.target)
      ) {
        setOptionactive(false);
      }
    };

    document.addEventListener("mousedown", checkIfClickedOutside);

    return () => {
      // Cleanup the event listener
      document.removeEventListener("mousedown", checkIfClickedOutside);
    };
  }, [Optionactive]);
  // const getClientData = () => {
  //   axios
  //     .get(
  //       `https://adyogiadsapi.adyogi.com/client/${client_id}/accounts?type=amazon_ad_account&fields=account_id,client_id,type,default_bid,region,brand_id,name,brand_keywords,suggested_bid,asins`
  //     )
  //     .then((response) => {
  //       console.log(response.data);
  //       if (response?.data?.data) {
  //         const {
  //           name,
  //           brand_keywords,
  //           brand_id,
  //           account_id,
  //           default_bid,
  //         } = response.data.data[0];
  //         localStorage.setItem("defaultBid", JSON.stringify(default_bid));
  //         localStorage.setItem("brandId", JSON.stringify(brand_id));
  //         localStorage.setItem("clientId", JSON.stringify(account_id));
  //         localStorage.setItem("clientName", JSON.stringify(name));

  //         // Another API Call for Reports API
  //         axios
  //           .get(
  //             `https://app1.adyogi.com/api/amzn/getCustomReports?accountId=${account_id}`
  //           )
  //           .then((response) => {
  //             console.log(response.data);
  //             setReportData(response.data);
  //             localStorage.setItem("reportData", JSON.stringify(response.data));
  //           });
  //         // Setting the Necessary ID's in Predefault Function For create campaign
  //         setCampaignData({
  //           ...campaignData,
  //           tenant_id: client_id,
  //           account_id: account_id,
  //         });
  //         setAdGroupData({
  //           ...adGroupData,
  //           account_id: account_id,
  //           amz_default_bid: default_bid,
  //         });
  //         setAdSetData({ ...adSetData, tenant_id: client_id });
  //       }
  //     });
  // };

  const updatedLayoutIfNoConfig = async () => {
    const response = await fetch(
      `https://adyogiadsapi.adyogi.com/client/${clientId}/custom-config`,
      {
        method: "POST",
        headers: {
          "Content-type": "application/json",
        },
        body: JSON.stringify({
          key: "amz_dashboard_config",
          value: {
            overview_metrices: [
              "impressions",
              "clicks",
              "orders",
              "sale_value",
            ],
            layout_order: [
              "overview",
              ...DEFAULT_DASHBOARD_LAYOUT,
            ],
          },
        }),
      }
    );
    const result = await response.json();
  };

  const getoverviewdata = async () => {
    const url = `
         https://adyogiadsapi.adyogi.com/client/${JSON.parse(
           localStorage.getItem("clientId")
         )}/custom-config?key=amz_dashboard_config`;

    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    };

    try {
      const response = await fetch(url, requestOptions);
      const result = await response.json();
      if (result.message) {
        updatedLayoutIfNoConfig();
      } else {
        let overdata = result.value.layout_order;
        localStorage.setItem("layoutId", JSON.stringify(result.id));
        let sp = overdata.filter(function (item) {
          return item !== "overview";
        });
        // If account Type vendor then hide product_summary
        const list = normalizeDashboardLayout(sp, client_type);
        setDashboardLayoutSequence(list);
        setItemList([...list]);
      }
    } catch (error) {
      console.log(error);
    }

    // axios
    //   .get(
    //     `
    //     https://adyogiadsapi.adyogi.com/client/${JSON.parse(
    //       localStorage.getItem("clientId")
    //     )}/custom-config?key=amz_dashboard_config`
    //   )
    //   .then((res) => {
    //     console.log(res.data,"Line also");
    //     console.log(res,"from global context")
    //     let overdata = res.data.value.layout_order;

    //     localStorage.setItem("layoutId", JSON.stringify(res.data.id));
    //     let sp = overdata.filter(function (item) {
    //       return item !== "overview";
    //     });
    //     setDashboardLayoutSequence(sp);
    //   });
  };
  useEffect(() => {
    document.addEventListener("mousedown", closeOpenMenus);
    return () => {
      // Cleanup the event listener
      document.removeEventListener("mousedown", closeOpenMenus);
    };
  }, [showCustomDateBox]);

  useEffect(() => {
    getoverviewdata();
  }, [overlayoutput, clientId]);

  useEffect(() => {
    setModalDashboard(dasboardLayoutSettingModalShow);
  }, [dasboardLayoutSettingModalShow, applyCalendar, datecount]);//[dasboardLayoutSettingModalShow, calendarDate, datecount]

  const onDateFOcusHandler = () => {
    setDateInFocus("date");
  };

  const getSelectedPortfolios = (names, idsByName = {}) => {
    setSelectedPortfolioName(names);
    setPortfolioIdByName((current) => ({ ...current, ...idsByName }));
  }
  const focusOutHandler = () => {
    setDateInFocus("text");
  };
  const settingBtnClickHandler = () => {
    // setShow(true)
    dispatch(dashboardActions?.dasboardLayoutSettingModalShow(true));
  };

  const closeOpenMenus = (e) => {
    if (
      calenderIconRefForDashboard.current &&
      showCustomDateBox &&
      !calenderIconRefForDashboard.current.contains(e.target)
    ) {
      setShowCustomDateBox(false);
    }
  };

  const dateInputClickHandler = (e) => {
    setShowCustomDateBox(!showCustomDateBox);
    setOptionactive(false);
    setBrandoption(false);
  };

  const dateChageHandler = () => {
    setShowCustomDateBox(true);
  };

  if(selectedPlatform ==='flipkart' || selectedPlatform ==='myntra') {
      return <HomeDashboardNew />
    }

  const pairSearchAndSummary =
    dashboardLayoutSequence.includes("low_performing_search_terms") &&
    dashboardLayoutSequence.includes("campaign_summary");
  const pairRenderIndex = pairSearchAndSummary
    ? Math.min(
        dashboardLayoutSequence.indexOf("low_performing_search_terms"),
        dashboardLayoutSequence.indexOf("campaign_summary")
      )
    : -1;
    
  return (
    <>
      <div
        className={
          dashboardSideBarVisibiltyState
            ? "main-content-container-onopen-mode"
            : "main-content-container-oncolapse-mode"
        }
        id="main-box"
      >
        <DashboardLayoutDialog
          open={modalShow}
          onClose={() => {
            dispatch(dashboardActions?.dasboardLayoutSettingModalHide());
          }}
          filters={dashboardFilters}
          onFiltersChange={updateDashboardFilters}
          onResetFilters={() => setDashboardFilters(DEFAULT_DASHBOARD_FILTERS)}
        />

        <Box
          className="horizontal-fixed"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 2,
            flexWrap: "nowrap",
            mb: 2,
          }}
        >
          <Box sx={{ minWidth: 0 }}>
            <DataLastUpdated />
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexShrink: 0 }}>
            <DashboardPortfolioSelect
              clientId={clientId || client_id}
              selectedNames={selectedPortfolioName}
              onApply={getSelectedPortfolios}
            />
            <IconButton
              aria-label="Dashboard layout settings"
              onClick={settingBtnClickHandler}
              sx={{
                width: 40,
                height: 40,
                "&:hover": { bgcolor: "#F6F6F7" },
              }}
            >
              <SettingsIcon />
            </IconButton>
          </Box>
        </Box>

        <div
          ref={calenderIconRefForDashboard}
          className={
            showCustomDateBox ? "calender-indashboard-container" : "hide"
          }
        >
          <CalenderComponent setShowCustomDateBox={setShowCustomDateBox} className="dashboard-calender-main"></CalenderComponent>
          <span className="calender-close-icon">
            <img
              onClick={() => setShowCustomDateBox(false)}
              src={closeIcon}
            ></img>
          </span>
        </div>

        <OverviewCardSection
          useAmazonOverview
          selectedPortfolios={selectedPortfolioName}
        />
        <div className="d-flex flex-column align-items-end justify-content-end w-100 small mt-2"> 
        <Link to={"/account-overview"} target="_blank" rel="noopener noreferrer">
          Click here for detailed analysis
        </Link>
        <span className="text-muted">Trend comparisons shown above is for current period vs preceding period*</span>
        </div>

        {dashboardLayoutSequence.map((el, i) => {
          if (el === "Keyword Low 10") {
          } else if (el === "trend_graph") {
            return (
              <PerformanceChart
                key={el}
                useAmazonOverview
                selectedPortfolios={selectedPortfolioName}
                leftMetricKey={dashboardFilters.chartLeftMetric}
                rightMetricKey={dashboardFilters.chartRightMetric}
                onLeftMetricKeyChange={(value) => updateDashboardFilters({ chartLeftMetric: value })}
                onRightMetricKeyChange={(value) => updateDashboardFilters({ chartRightMetric: value })}
                timePeriod={dashboardFilters.chartTimePeriod}
                onTimePeriodChange={(value) => updateDashboardFilters({ chartTimePeriod: value })}
              />
            );
          } else if (
            el === "campaign_summary" ||
            el === "low_performing_search_terms"
          ) {
            if (pairSearchAndSummary) {
              if (i !== pairRenderIndex) return null;
              const searchFirst =
                dashboardLayoutSequence.indexOf("low_performing_search_terms") <
                dashboardLayoutSequence.indexOf("campaign_summary");
              const pair = searchFirst
                ? [
                    <LowPerformingSearchTerms
                      key="low_performing_search_terms"
                      selectedPortfolios={selectedPortfolioName}
                      sx={{ mb: 0 }}
                    />,
                    <CampaignSummary
                      key="campaign_summary"
                      selectedPortfolios={selectedPortfolioName}
                      sx={{ mb: 0 }}
                      tab={dashboardFilters.campaignTab}
                      onTabChange={(value) => updateDashboardFilters({ campaignTab: value })}
                      metricKey={dashboardFilters.campaignMetric}
                      onMetricKeyChange={(value) => updateDashboardFilters({ campaignMetric: value })}
                    />,
                  ]
                : [
                    <CampaignSummary
                      key="campaign_summary"
                      selectedPortfolios={selectedPortfolioName}
                      sx={{ mb: 0 }}
                      tab={dashboardFilters.campaignTab}
                      onTabChange={(value) => updateDashboardFilters({ campaignTab: value })}
                      metricKey={dashboardFilters.campaignMetric}
                      onMetricKeyChange={(value) => updateDashboardFilters({ campaignMetric: value })}
                    />,
                    <LowPerformingSearchTerms
                      key="low_performing_search_terms"
                      selectedPortfolios={selectedPortfolioName}
                      sx={{ mb: 0 }}
                    />,
                  ];
              return (
                <Box
                  key="lpst-campaign-summary-split"
                  sx={{
                    display: "grid",
                    gridTemplateColumns: {
                      xs: "1fr",
                      lg: searchFirst
                        ? "minmax(0, 1.5fr) minmax(0, 1fr)"
                        : "minmax(0, 1fr) minmax(0, 1.5fr)",
                    },
                    gap: 2,
                    mb: 4,
                    alignItems: "stretch",
                  }}
                >
                  {pair}
                </Box>
              );
            }
            if (el === "campaign_summary") {
              return (
                <CampaignSummary
                  selectedPortfolios={selectedPortfolioName}
                  key={el}
                  tab={dashboardFilters.campaignTab}
                  onTabChange={(value) => updateDashboardFilters({ campaignTab: value })}
                  metricKey={dashboardFilters.campaignMetric}
                  onMetricKeyChange={(value) => updateDashboardFilters({ campaignMetric: value })}
                />
              );
            }
            return (
              <LowPerformingSearchTerms
                selectedPortfolios={selectedPortfolioName}
                key={el}
              />
            );
          } else if (el === "category_product_performance_summary") {
            return <PerformanceSummary key={el} view={dashboardFilters.performanceView} />;
          } else if (el === "targeting") {
            return (
              <TargetingInsights
                selectedPortfolios={selectedPortfolioName}
                key={el}
                viewType={dashboardFilters.targetingView}
                onViewTypeChange={(value) => updateDashboardFilters({ targetingView: value })}
                performerType={dashboardFilters.targetingPerformer}
                onPerformerTypeChange={(value) => updateDashboardFilters({ targetingPerformer: value })}
              />
            );
          } else if (el === "product_summary") {
            return (client_type === "seller") ? <ProductSummary portfoliosIds={portfoliosIds} portfolios={selectedPortfolioName} key={el} activeView={dashboardFilters.productSummaryView} onActiveViewChange={(value) => updateDashboardFilters({ productSummaryView: value })}></ProductSummary>:false;
          } else if (el === "Top Selling Product") {
          } else if (el === "Key Insights") {
          }
        })}
      </div>
    </>
  );
};

export default HomeDashboard;
